














































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import moment from 'moment';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: [];

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                if (moment.isMoment(fieldValue)) {
                  _.set(values, [key], moment(fieldValue).format('YYYY-MM-DD'));
                } else if (key === 'price') {
                  _.set(values, [key], this.tsMul(fieldValue, 100));
                } else {
                  _.set(values, [key], fieldValue);
                }
              }
            }
            const res = await this.$store.dispatch('stadium/addpriceextend', {
              stadium_id: this.stadiumId,
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
